import { createTranslationsPageProvider } from '@edreamsodigeo/frontend-core';
export const RegisterPageTranslationsFunnelProvider = createTranslationsPageProvider({
  userAuthentication: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-user-authentication/translations/${brand}/${locale}/registration.js`)
});